export const ReviewDays = [
  {
    label: "Days",
    value: "Days"
  },
  {
    label: "Weeks",
    value: "Weeks"
  },
  {
    label: "Months",
    value: "Months"
  }
]

export const validateProject = (value) => {
  if (/^[a-zA-Z][a-zA-Z0-9]+$/.test(value)) {
    return true;
  }
  return false;
};

export const OWNER_ROLE_MAP = {
  Primary: { title: 'Primary Owner', displayName: "P" },
  Secondary: { title: 'Secondary Owner', displayName: "S" },
};
